/**
 * @generated SignedSource<<d8f22a98c345bb18a9805c6ad2f0eea3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templatePaginatedSearchResultsRelayRefetchableFragment$data = {
  readonly templates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null | undefined;
        readonly templateId: string;
        readonly urlSlug: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"templateCardRelayFragment">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  };
  readonly " $fragmentType": "templatePaginatedSearchResultsRelayRefetchableFragment";
};
export type templatePaginatedSearchResultsRelayRefetchableFragment$key = {
  readonly " $data"?: templatePaginatedSearchResultsRelayRefetchableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templatePaginatedSearchResultsRelayRefetchableFragment">;
};

import templatePaginatedSearchResultsRefetchableQuery_graphql from './templatePaginatedSearchResultsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": templatePaginatedSearchResultsRefetchableQuery_graphql
    }
  },
  "name": "templatePaginatedSearchResultsRelayRefetchableFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "queries.0",
                  "variableName": "searchQuery"
                }
              ],
              "kind": "ListValue",
              "name": "queries"
            }
          ],
          "kind": "ObjectValue",
          "name": "search"
        }
      ],
      "concreteType": "ContentPlatformTemplateContentSearchConnection",
      "kind": "LinkedField",
      "name": "templates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplateResultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentPlatformTemplate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlSlug",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "templateCardRelayFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "dac86ac8a8eb6ab17bdc9f6204cf08bc";

export default node;
